import matterportTourPreview from "./Matterport-Tour-Preview.png";
import onSite from "./Measurement-01-On-site-measurement.png";
import procedure from "./Measurement-02-What-is-the-procedure.png";
import calculator from "./Measurement-03-Cost-Calculator.png";

export { calculator, matterportTourPreview, onSite, procedure };
